import { Link } from 'react-router-dom';
import styled, { StyledProps } from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import { primitive } from 'styles/constants/primitives';

export const BordersAndBackground = styled.div`
  width: 100%;
  margin-bottom: ${primitive.$spacing7};
  padding: ${primitive.$spacing2};
  background-color: transparent;
  border: 1px solid ${p => p.theme.token('border-color-default')};
  border-width: 1px 0 1px;
  text-align: center;

  ${Styles.desktop`
    background-color: ${(p: StyledProps<{}>) => p.theme.token('background-default')};
    border-width: 1px;
    border-color: #d0d0d0;
    border-radius: 10px;
  `}
`;

export const StyledLink = styled(Link)`
  color: ${p => p.theme.token('text-link-default')};
  font: ${brandFont.headerThree};
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: -0.5px;

  :hover {
    color: ${p => p.theme.token('text-link-hover')};
  }
`;

export const VerifyNowText = styled.h5`
  margin: 0;
  color: ${p => p.theme.token('text-default')};
  font: ${brandFont.copyOne};
  letter-spacing: -0.5px;
`;
